import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default {
  init() {

    var $posts_block = $('.projects-list');
    animate_posts('.projects-list .post.post-project');

    var scroll_func = function() {
      // Block calls if there are no more posts to retrieve
      if( ! $posts_block.hasClass('complete')){
        // Check if user has reached block end
        if ($(window).scrollTop() >= $posts_block.offset().top + $posts_block.outerHeight() - window.innerHeight) {
          // Block calls if a call is still loading
          if( ! $posts_block.hasClass('loading') ){
            load_posts();
          }
        }
      }
    };

    //Load posts via scroll to bottom
    if( ! $posts_block.hasClass('complete') ){
      $(window).on('scroll', scroll_func);
    }

    //Load posts via user click
    $('.load-more-posts').click(function (e) {
      e.preventDefault();
      load_posts();
    });//End .load-more-cpts
  },
};

function animate_posts(itemsSelector, currentPage = 0){
  const items = gsap.utils.toArray(itemsSelector);

  items.forEach((item, key) => {
    if(key >= (6 * currentPage)){
      let tl = gsap.timeline();
      tl.to(item, { y: 100, autoAlpha: 0, opacity: 0, duration: 0 });
      tl.to(item, { y: 0, autoAlpha: 1, opacity: 1, duration: 0.6 });

      ScrollTrigger.create({
        trigger: item,
        animation: tl,
        toggleActions: 'play none none none',
        once: true,
      });

      ScrollTrigger.refresh();
    }
  });
}

function load_posts(){
  //debugger; // eslint-disable-line

  // eslint-disable-next-line no-undef
  var ajax_url = ajax_object.ajax_url,
  security = $('#security').val(),
  $button = $('.load-more-posts'),
  $loader = $('.loader-points'),
  $current_page = $('#load-more-posts-page'),
  $posts_per_page = $('#load-more-posts-ppp'),
  $template = $('#load-more-posts-template'),
  $type = $('#load-more-posts-type'),
  $posts_block = $('.projects-list'),
  $posts = $('.projects-list .post-project'),
  $post_in = [],
  $i = 0;

  // Enseñamos el Loading y ocultados el Cargar más
  $button.addClass('hidden');
  $posts_block.addClass('loading');

  $posts.each( function () {
    $post_in[$i++] = $(this).attr('data-id');
  })

  $.ajax({
    type: 'POST',
    dataType: 'json',
    url: ajax_url,
    data: {
      'action': 'get_more_posts',
      'page': $current_page.val(),
      'type': $type.val(),
      'template': $template.val(),
      'posts_per_page': $posts_per_page.val(),
      'security': security,
      'post_in': JSON.stringify($post_in),
    },
    success: function (data) {
      var $list = $('.projects-list .wrap');
      $button.removeClass('hidden');
      $posts_block.removeClass('loading');

      new Promise(resolve => {
        if (data.hay_elementos === true) {
          $list.append(data.html);
          $current_page.val( parseInt( $current_page.val() ) + 1 );

          let boxedTexts = document.getElementsByClassName('post-project');
          if(boxedTexts.length > 0){
            Array.prototype.slice.call(boxedTexts).forEach( boxedText => {
              boxedText.classList.add('loaded');
              let anchorBT = boxedText.children[1];
              boxedText.addEventListener('mouseover', ()=>{
                if(!anchorBT.classList.contains('visible')){
                  anchorBT.classList.add('visible');
                }
              });
              boxedText.addEventListener('mouseleave', ()=>{
                if(anchorBT.classList.contains('visible')){
                  anchorBT.classList.remove('visible');
                }
              });
            });
            resolve();
          }
        }else {
          $loader.fadeOut('slow', function () {
            // Change link to message
            $button.remove();
            $button.css('cursor: none;');
            $posts_block.addClass('complete');
            return 'complete';
          });
        }
        return '';
      }).then(()=>{
        animate_posts('.projects-list .post.post-project', $current_page.val() - 1);

        // Refresh to recalculate triggers positions
      });




    },
    error: function (errorThrown) {
      $button.removeClass('hidden');
      $posts_block.removeClass('loading');

      console.log( errorThrown );
    },
  });
}
